import React, { memo } from 'react';
import InfoMsg from '../../common/InfoMsg/InfoMsg';
import s from './LokSabhaSeating.scss';

const LokSabhaSeating = ({
  parties,
  colorMap,
  totalSeats = 0,
  activeSeats = 0,
  leadPlusWinCount = {},
  leadObject,
  infoMsg = '',
  majority = 0,
}) => {
  const PathsData = [
    {
      path:
        'M122.1,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M122.1,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M122.1,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M111.2,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M111.2,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M111.2,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M99.1,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M99.1,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M99.1,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.2,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.2,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.2,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.2,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.3,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.3,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.3,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.3,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M62.9,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M62.9,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M62.9,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M62.9,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M38.9,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M38.9,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M38.9,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M38.9,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M14.8,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M14.8,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M14.8,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M14.8,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M2.7,196.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M2.7,191.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M2.7,185.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M2.7,180.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M122.4,170.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M123.1,166.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M111.2,170c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M111.7,165.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M113.4,161c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M99.3,169.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M99.8,164.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M100.8,160c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M102.5,155.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.2,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M87.7,163.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M88.6,158.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M90.1,154c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M91.8,149.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.3,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M75.5,163.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M76.5,158.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M77.7,153.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M79.4,148.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M81.3,143.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M62.9,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M63.4,163.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M64.1,158.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M65.1,152.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M66.5,147.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M68.5,142.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M70.7,137.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M51.2,163.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M52,158.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M52.9,152.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M54.4,147.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M56.1,141.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M58,136.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M60.2,131.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M39.1,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M39.3,163.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M39.8,158.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M40.8,152.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M42,147.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M43.5,141.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M45.2,136.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M47.3,130.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M49.8,125.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27.2,163.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M27.7,158.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M28.7,152.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M29.6,147.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M30.8,141.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M32.5,136.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M34.5,130.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M36.7,125.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M39.1,120.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M14.8,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M15.1,163.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M15.5,157.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M16.3,152.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M17.5,146.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M18.5,141.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M19.9,135.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M21.6,130.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M23.8,124.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M26,119.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M28.4,114.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M2.7,169.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M3.1,163.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M3.4,157.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M4.2,151.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M5.2,146.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M6.5,140.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M7.8,135.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M9.1,129.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M10.8,124.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M13.1,118.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M15.3,113.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M17.8,108.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M126,156.7c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M128.7,153.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M116.4,150.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M119.2,147.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M122.8,144.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M106.3,144.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M109.1,140.8c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M112.4,137.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M116.3,133.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M96,138.3c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M99.1,133.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M102.5,130c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M106.2,126.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M109.9,123.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M85.7,132.3c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M88.6,127.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M92.2,123.5c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M95.8,119.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M99.8,116.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M103.8,113.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M75,126.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M78.2,121.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M81.6,117.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M85.1,112.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M88.9,109.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M93.3,105.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M97.5,102.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M64.7,120.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M67.5,115.7c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M71.1,111c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M74.6,106.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M78.6,102.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M82.8,99c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M87.1,95.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M91.3,92.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M54.4,114.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M57.4,109.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M60.6,104.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M64.1,100.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M67.9,96.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M71.9,92.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M76.1,88.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M80.7,85.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M85.3,82c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M43.8,108.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M46.8,103.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M50.1,98.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M53.7,94.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M57.2,90.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M61,86.2c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M65.2,82.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M69.7,78.5c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M74.2,75c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M78.9,71.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M33.3,102.1c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M36.4,97.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M39.7,92.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M43.1,88.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M46.9,83.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M50.4,79.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M54.5,75.6c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M58.6,71.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M63.3,68.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M67.9,64.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M72.5,61.4c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M22.8,96c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M26.2,90.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M29.4,86c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M32.9,81.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M36.6,77.3c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M40.5,73.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M44.2,69.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M48.1,64.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M52.3,61.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M57.1,57.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M61.7,54.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M66.4,50.9c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7c-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M137.1,146.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M141,145.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M131.7,137.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M135.9,135.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M140.6,134.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M126,126.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M130.4,124.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M135.1,123c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M140.2,122.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M120.3,115.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M125.2,113.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M130.1,111.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M135,110.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M139.9,109.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M114.4,105.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M119.1,103.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M124.4,101.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M129.5,99.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M134.7,98.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M139.7,98c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M108.2,94.9c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M113.2,92.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M118.4,90.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M123.6,88.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M128.7,87.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M134.3,86.2c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M139.4,85.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M102.2,84.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M107,82.1c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M112.4,79.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M117.5,78c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M123.1,76.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M128.5,75.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M134.1,74.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M139.2,73.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M96.3,74.2c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M101.2,71.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M106.3,69.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M111.4,67.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M116.9,65.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M122.2,64.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M127.9,63c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M133.6,62.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M139.3,61.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M90.2,63.7c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M95.2,61.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M100.2,58.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M105.6,56.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M110.7,55c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M116.1,53.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M121.6,52.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M127.4,50.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M133.1,50.2c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M138.7,49.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M84.1,53.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M89.3,50.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M94.4,48.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M99.6,46c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M105,44.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M110.1,42.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M115.7,40.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M121.2,39.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M127.1,38.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M132.8,38c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M138.5,37.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M78.1,42.7c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M83.6,40c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M88.8,37.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M94,35.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M99.4,33.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M104.8,31.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M110.1,30.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M115.5,28.4c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M121,27.3c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M127,26.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M132.7,25.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M138.3,25.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M153.6,146.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M157.5,148.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M153.9,135.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M158.5,136.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M162.8,138.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.2,123.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M159.3,124.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M164,125.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M168.4,127.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.4,111.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M159.3,111.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M164.2,113.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M169.1,114.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M174,116.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.5,99.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M159.4,99.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M164.7,100.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M169.8,102.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M175.1,104.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M179.9,106.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.7,87c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M159.8,87.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M165.4,88.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M170.5,89.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M175.7,91.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M180.9,93.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M186,95.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.7,75.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M159.8,75.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M165.4,76.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M170.9,77.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M176.5,79c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M181.6,80.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M187.1,83c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M191.8,85.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M154.6,63c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M160.2,63.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M166,64.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M171.7,65.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M177,66.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M182.5,68.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M187.6,70.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M192.7,72.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M197.7,75.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M155,50.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M160.6,51.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M166.4,52.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M172.2,53.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M177.7,54.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M183.1,56c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M188.3,57.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M193.6,59.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M198.7,62c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M203.7,64.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M155.2,38.8c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M160.8,39.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M166.6,39.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M172.5,40.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M178,41.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M183.6,43.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M188.7,45.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M194.1,46.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M199.4,49c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M204.5,51.3c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M209.7,54c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M155.2,26.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M160.8,26.9c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M166.6,27.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M172.5,28.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M178,29.5c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M183.5,31.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M188.8,32.6c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M194.3,34.2c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M199.6,36.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M204.9,38.1c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M210.1,40.7c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M215.6,43.4c1.1,0,1.9-.9,1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9,1.9.9,1.9,1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M165,153.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M167.7,156.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M170.8,144.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M174.5,147c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M177.2,150.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M177.3,133.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M181.2,136.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M184.5,140.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M187.4,144.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M183.5,123.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M187.3,126.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M191,129.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M194.5,133.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M197.6,137.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M189.6,112.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M193.6,115.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M197.6,119.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M201.2,123.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7s-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M204.9,127.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M207.8,131.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M195.8,102.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M200,105.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M204.4,108.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M208.3,112.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M211.8,116.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M215.3,121c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M218.5,125.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M201.8,92c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M206.1,94.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M210.5,98.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M214.6,102.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M218.7,106.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M222.3,110.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M225.8,115.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M228.8,119.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M207.8,81.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M212.4,84.6c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M217,88.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M221.3,92.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M225.3,95.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M229.2,100.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M232.7,104.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M236,108.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M239,113.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M214.1,71.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M218.8,74.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M223.4,77.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M227.9,81.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M232.1,85.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M236,89.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M239.5,93.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M243.2,98.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M246.4,102.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M249.5,107.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M220.4,60.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M225.1,64c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M229.7,67.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M234.4,71.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M238.6,74.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M242.6,79c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M246.2,83.1c.9.5,2.1.2,2.7-.7s.2-2.1-.7-2.7-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M250.1,87.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M253.5,91.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M256.8,96.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M259.9,101.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M226.5,50.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M231.2,53.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M235.8,56.8c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M240.6,60.5c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M244.8,64.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M248.7,68.3c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M252.6,72.2c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7s-2.1-.2-2.7.7c-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M256.5,76.4c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M260.2,80.7c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M263.7,85.1c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M267,89.9c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M270.4,95c.9.5,2.1.2,2.7-.7.5-.9.2-2.1-.7-2.7-.9-.5-2.1-.2-2.7.7-.5.9-.2,2.1.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M170.6,165.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M171.3,169.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M180.2,159.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M182,164.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M182.5,168.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M191.1,154c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M192.9,158.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M193.9,163.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M194.4,168.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M201.8,148.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M203.5,152.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M205,157.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M206,162.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M206.5,167.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M212.1,142.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M214.1,146.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M215.9,151.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M217.1,156.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M218.1,162.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M218.4,167.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M222.8,136.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M225,140.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M227,146.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M228.5,151.2c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M229.5,156.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M230.3,162.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M230.8,167.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M233.2,130.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M235.4,134.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M237.4,140.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M239.1,145.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M240.6,151.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M241.7,156.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M242.4,162.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M242.7,167.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M243.6,124.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M246,129.2c.5.9,1.7,1.2,2.7.7s1.2-1.7.7-2.7c-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M248.3,134.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M250,140.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M251.5,145.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7s-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M252.8,151c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M253.8,156.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7s-1.7-1.2-2.7-.7c-.9.5-1.2,1.7-.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M254.3,162c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M254.6,167.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M254.2,118.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7h0Z',
      color: '#ececec',
    },
    {
      path:
        'M256.7,123.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M258.9,128.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M260.9,134.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M262.6,139.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M263.9,145.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M264.9,150.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M265.9,156.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M266.5,161.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M266.8,167.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M264.8,112.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M267.3,117.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M269.5,123c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M271.8,128.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M273.5,133.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M275,139.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M276,144.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M277.3,150.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M278.1,155.9c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M278.6,161.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M278.9,167.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M275.4,106.5c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M277.9,111.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M280.2,116.8c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M282.5,122.4c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M284.3,127.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M285.6,133.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M287,138.6c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M288.3,144.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M289.4,149.7c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M290.2,155.3c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M290.6,161.1c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M291,167.2c.5.9,1.7,1.2,2.7.7.9-.5,1.2-1.7.7-2.7-.5-.9-1.7-1.2-2.7-.7-.9.5-1.2,1.7-.7,2.7Z',
      color: '#ececec',
    },
    {
      path:
        'M173.6,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M173.6,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M173.6,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M184.6,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M184.6,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M184.6,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M196.7,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M196.7,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M196.7,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M208.6,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M208.6,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M208.6,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M220.5,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M220.5,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M220.5,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M220.5,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M232.9,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M232.9,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M232.9,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M232.9,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M244.8,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M244.8,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M244.8,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M244.8,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M256.9,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M256.9,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M256.9,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M256.9,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M268.8,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M268.8,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M268.8,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M268.8,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M281,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M281,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M281,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M281,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M293.1,180.3c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M293.1,185.9c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M293.1,191.2c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
    {
      path:
        'M293.1,196.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9,1.9.9,1.9,1.9-.9,1.9-1.9,1.9Z',
      color: '#ececec',
    },
  ];
  let lastTotal = 0;
  try {
    for (let index = 0; index < parties.length; index += 1) {
      for (
        let i = lastTotal;
        i < lastTotal + (parties[index]?.ls || 0) + (parties[index]?.ws || 0);
        i += 1
      ) {
        PathsData[i].color = colorMap?.[parties[index]?.nm]?.cc || '#eee';
      }
      lastTotal += (parties?.[index]?.ls || 0) + (parties?.[index]?.ws || 0);
    }
  } catch (error) {
    // Some error
  }
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        version="1.1"
        viewBox="0 0 296 202"
      >
        <defs>
          <style>
            {`.cls-1, .cls-2, .cls-3 {
        fill: none;
      }

      .cls-1, .cls-4, .cls-5, .cls-6 {
        stroke-width: 0px;
      }

      .cls-2 {
        stroke: #b17979;
        stroke-miterlimit: 10;
        stroke-width: 1.2px;
      }

      .cls-2, .cls-3 {
        stroke-linecap: round;
      }

      .cls-7 {
        fill: #595959;
        font-size: 12px;
      }

      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {
        isolation: isolate;
      }

      .cls-8 {
        fill: #000;
      }

      .cls-8, .cls-9, .cls-10 {
        font-size: 12px;
      }

      .cls-3 {
        stroke: #ccc;
      }

      .cls-4, .cls-9, .cls-10 {
        fill: #1a1a1a;
      }

      .cls-4, .cls-11 {
        display: none;
      }

      .cls-9, .cls-10 {
        font-weight: 700;
      }

      .cls-10 {
        letter-spacing: 0em;
      }

      .cls-6 {
        fill: #ccc;
      }`}
          </style>
        </defs>
        <rect className="cls-1" y="0" width="296" height="202" />
        <g>
          <path className="cls-2" d="M274.6,177.1v20.6" />
          <path className="cls-2" d="M202.9,177.2v14.1" />
          <path className="cls-2" d="M214.4,177.1v20.6" />
          <path className="cls-2" d="M226.8,177.1v20.6" />
          <path className="cls-2" d="M238.7,177.1v20.6" />
          <path className="cls-2" d="M250.8,177.1v20.6" />
          <path className="cls-2" d="M263,177.1v20.6" />
          <path className="cls-2" d="M168.7,177.2v14.1" />
          <path className="cls-2" d="M178.4,177.2v14.1" />
          <path className="cls-2" d="M190.6,177.2v14.1" />
          <path className="cls-2" d="M287,177.1v20.6" />
          <path className="cls-2" d="M238.4,169.6s1.5-19.7-10.2-40.1" />
          <path className="cls-2" d="M226.5,169.7s.2-18.9-8.9-34" />
          <path className="cls-2" d="M262.6,169.4s0-29.2-13.7-52" />
          <path className="cls-2" d="M274.5,169.3s1.9-27.6-14.9-58" />
          <path className="cls-2" d="M286.7,169.2s2.2-31.1-16.5-63.8" />
          <path className="cls-2" d="M250.5,169.5s1.5-23.5-11.9-46.2" />
          <path className="cls-2" d="M214.3,169.8s.6-14.2-7.2-28.1" />
          <path className="cls-2" d="M202.4,169.9s.4-12.3-5.7-22.4" />
          <path className="cls-2" d="M190.2,169.9s.2-8.2-3.9-16.2" />
          <path className="cls-2" d="M178,170s.7-5.2-2.3-10.2" />
          <path className="cls-2" d="M168.4,170.2s.3-3.3-1-5.9" />
          <path className="cls-2" d="M226,123.5s-8.5-17.8-28.9-29.6" />
          <path className="cls-2" d="M215.7,129.5s-9.3-16.5-24.7-25" />
          <path className="cls-2" d="M246.9,111.1s-14.7-25.3-37.8-38.2" />
          <path className="cls-2" d="M257.2,105.1s-12.2-24.8-42-42.8" />
          <path className="cls-2" d="M267.6,98.9s-13.6-28-46.2-47" />
          <path className="cls-2" d="M236.4,117.3s-10.5-21.1-33.4-34" />
          <path className="cls-2" d="M205.3,135.6s-6.6-12.6-20.3-20.7" />
          <path className="cls-2" d="M195,141.7s-5.8-10.9-16.1-16.6" />
          <path className="cls-2" d="M184.4,147.8s-3.9-7.2-11.5-12.1" />
          <path className="cls-2" d="M173.9,154s-2-4.8-7.1-7.7" />
          <path className="cls-2" d="M165.7,158.9s-1.4-3-3.8-4.6" />
          <path className="cls-2" d="M191.4,90.2s-16.3-11.2-39.8-11.2" />
          <path className="cls-2" d="M185.5,100.6s-16.3-9.6-33.9-9.3" />
          <path className="cls-2" d="M203.3,69.1s-25.3-14.6-51.8-14.1" />
          <path className="cls-2" d="M209.2,58.7s-23-15.4-57.7-16.1" />
          <path className="cls-2" d="M215.2,48.2s-25.8-17.5-63.6-17.6" />
          <path className="cls-2" d="M197.4,79.7s-19.6-13-45.9-12.8" />
          <path className="cls-2" d="M179.5,111.2s-12-7.6-27.9-7.8" />
          <path className="cls-2" d="M173.7,121.5s-10.5-6.5-22.2-6.3" />
          <path className="cls-2" d="M167.5,132.1s-7-4.3-16-4.8" />
          <path className="cls-2" d="M161.5,142.7s-4.2-3.2-10-3.1" />
          <path className="cls-2" d="M156.9,151.1s-2.7-1.9-5.6-2.1" />
          <path className="cls-2" d="M104.4,90.3s17.3-11,39.7-11.6" />
          <path className="cls-2" d="M110.4,100.6s16.9-9.7,33.9-9.6" />
          <path className="cls-2" d="M92.3,69.3s26.6-15.3,51.7-14.6" />
          <path className="cls-2" d="M86.3,59s23.9-14.8,57.6-16.6" />
          <path className="cls-2" d="M80.3,48.4s26.6-16.5,63.4-18.1" />
          <path className="cls-2" d="M98.3,79.8s20.6-12.6,45.8-13.1" />
          <path className="cls-2" d="M116.4,111.1s11.5-6.8,27.9-8" />
          <path className="cls-2" d="M122.4,121.4s11-6.2,22.2-6.5" />
          <path className="cls-2" d="M128.6,132s8.7-4.8,15.9-4.8" />
          <path className="cls-2" d="M134.7,142.5s4.6-2.7,9.9-3.2" />
          <path className="cls-2" d="M139.4,150.9s2.7-1.4,5.4-2.1" />
          <path className="cls-2" d="M69.4,124.1s9.5-18.2,28.6-29.9" />
          <path className="cls-2" d="M79.7,130s9.8-16.8,24.5-25.2" />
          <path className="cls-2" d="M48.4,111.9s15.4-26.5,37.5-38.5" />
          <path className="cls-2" d="M38.1,106s13.3-24.7,41.6-43.1" />
          <path className="cls-2" d="M27.6,99.9s14.7-27.6,45.8-47.4" />
          <path className="cls-2" d="M58.9,118s11.6-21.2,33.1-34.3" />
          <path className="cls-2" d="M90.2,136.1s6.5-11.7,20.1-20.9" />
          <path className="cls-2" d="M100.6,142s6.4-10.8,16-16.7" />
          <path className="cls-2" d="M111.2,148.1s5.2-8.5,11.3-12.1" />
          <path className="cls-2" d="M121.7,154.1s2.7-4.6,7-7.7" />
          <path className="cls-2" d="M130,159s1.6-2.6,3.6-4.5" />
          <path className="cls-2" d="M57.1,170.2s-.8-20.5,9.8-40.2" />
          <path className="cls-2" d="M69,170.2s0-19.5,8.6-34.1" />
          <path className="cls-2" d="M32.8,170.2s0-30.6,13.2-52.1" />
          <path className="cls-2" d="M20.9,170.2s-.8-28,14.4-58.2" />
          <path className="cls-2" d="M8.7,170.2s-1-31.3,16-64" />
          <path className="cls-2" d="M44.9,170.2s-.6-24.2,11.5-46.3" />
          <path className="cls-2" d="M81.1,170.2s-.2-13.4,7-28.2" />
          <path className="cls-2" d="M93,170.2s0-12.6,5.5-22.5" />
          <path className="cls-2" d="M105.3,170.1s.2-10,3.8-16.1" />
          <path className="cls-2" d="M117.4,170.1s0-5.3,2.2-10.2" />
          <path className="cls-2" d="M127,170.2s0-3,.8-5.7" />
          <path className="cls-2" d="M21.1,176.9v20.6" />
          <path className="cls-2" d="M92.8,177v14.1" />
          <path className="cls-2" d="M81.3,176.9v20.6" />
          <path className="cls-2" d="M69,176.9v20.6" />
          <path className="cls-2" d="M57.1,176.9v20.6" />
          <path className="cls-2" d="M44.9,176.9v20.6" />
          <path className="cls-2" d="M32.8,176.9v20.6" />
          <path className="cls-2" d="M127.1,177v14.1" />
          <path className="cls-2" d="M117.3,177v14.1" />
          <path className="cls-2" d="M105.1,177v14.1" />
          <path className="cls-2" d="M8.7,176.9v20.6" />
          {PathsData.map((pathData, index) => (
            <path
              key={index}
              d={pathData.path}
              fill={pathData.color}
              className="cls-5"
            />
          ))}
        </g>
        <path
          className="cls-6"
          d="M148,19l-2.9,5h5.8l-2.9-5h0ZM147.5,149c0,.3.2.5.5.5s.5-.2.5-.5h-1ZM147.5,23.5v125.5h1V23.5h-1Z"
        />
        <path
          className="cls-4"
          d="M151.4,163.2c0,.7,0,1.4-.2,2-.1.6-.3,1.1-.6,1.4-.3.4-.7.7-1.1.9-.5.2-1,.3-1.7.3s-1.2,0-1.7-.3c-.5-.2-.8-.5-1.1-.9s-.5-.9-.6-1.4c-.1-.6-.2-1.2-.2-2s0-1.4.2-2c.1-.6.3-1,.6-1.4s.7-.7,1.1-.9c.5-.2,1-.3,1.7-.3s1.2,0,1.7.3c.5.2.8.5,1.1.9s.5.9.6,1.4c.1.6.2,1.2.2,1.9h0ZM149.1,163.2c0-1.1-.1-1.8-.3-2.2s-.6-.7-1-.7-.8.2-1,.7c-.2.4-.3,1.2-.3,2.3s.1,1.8.3,2.2c.2.5.6.7,1,.7s.8-.2,1-.7.3-1.2.3-2.2h0Z"
        />
        <path className="cls-3" d="M135.1,177.9h26" />
        <path
          className="cls-4"
          d="M151.4,187.2c0,.7,0,1.4-.2,2-.1.6-.3,1.1-.6,1.4-.3.4-.7.7-1.1.9-.5.2-1,.3-1.7.3s-1.2,0-1.7-.3c-.5-.2-.8-.5-1.1-.9s-.5-.9-.6-1.4c-.1-.6-.2-1.2-.2-2s0-1.4.2-2c.1-.6.3-1,.6-1.4s.7-.7,1.1-.9c.5-.2,1-.3,1.7-.3s1.2,0,1.7.3c.5.2.8.5,1.1.9s.5.9.6,1.4c.1.6.2,1.2.2,1.9h0ZM149.1,187.2c0-1.1-.1-1.8-.3-2.2s-.6-.7-1-.7-.8.2-1,.7c-.2.4-.3,1.2-.3,2.3s.1,1.8.3,2.2c.2.5.6.7,1,.7s.8-.2,1-.7.3-1.2.3-2.2h0Z"
        />
        <text className="cls-7" transform="translate(120.4 12.7)">
          <tspan x="0" y="0">
            Majority: {majority}
          </tspan>
        </text>
        <text
          className="cls-9"
          style={{
            'text-anchor': 'middle',
          }}
          textAnchor="middle"
          transform="translate(148.1 192.4)"
        >
          <tspan x="0" y="0">
            {totalSeats}
          </tspan>
        </text>
        <text
          className="cls-10"
          style={{
            'text-anchor': 'middle',
          }}
          textAnchor="middle"
          transform="translate(148.1 170.1)"
        >
          <tspan x="0" y="0">
            {leadPlusWinCount?.leadPlusWinCount || '0'}
          </tspan>
        </text>
      </svg>
      <div className={s.infoStrip}>
        <div className={s.totalSeats}>
          <span>Seats: </span>
          {activeSeats} {infoMsg && <InfoMsg msg={infoMsg} />}
        </div>
        {leadPlusWinCount && (
          <div className={s.leadWins}>
            {leadPlusWinCount?.winCount === activeSeats ? 'Results' : 'L + W'}
          </div>
        )}
        <div className={s.resultStatus}>
          <span style={{ color: leadObject.color }}>{leadObject.party}</span>{' '}
          {leadObject?.text}
        </div>
      </div>
    </>
  );
};

export default memo(LokSabhaSeating);
